/** How the client sounds in a ticket (`ticket.sentiment`, mirrored from `app/core/constants/service_desk_sentiment.py`). */
export const TICKET_SENTIMENT_VALUES = ["negative", "neutral", "positive"] as const;
export type TicketSentiment = (typeof TICKET_SENTIMENT_VALUES)[number];
